// KeyFiguresSmallWidget.js
import React from 'react';
import { Box, Typography } from '@mui/material';
import CardHeader from '../shared/CardHeader';
import CardContainer from '../shared/CardContainer';
import ArrowDropDownOutlinedIcon from '@mui/icons-material/ArrowDropDownOutlined';
import ArrowDropUpOutlinedIcon from '@mui/icons-material/ArrowDropUpOutlined';
import { formatNumberDE } from '../../../../../../shared/utils/formatNumber';

const KeyFiguresSmall = ({
  title = 'N/A',
  keyFigureType = 'N/A',
  contractFigure = 'N/A',
  data = {},
}) => {
  const rawKeyFigure = data[keyFigureType] || 'N/A';
  const keyFigure = !isNaN(parseFloat(rawKeyFigure))
    ? formatNumberDE(parseFloat(rawKeyFigure))
    : rawKeyFigure;
  let keyFigureColor = 'inherit';
  let IconComponent = null;

  if (contractFigure !== 'N/A' && rawKeyFigure !== 'N/A') {
    const keyFigureValue = parseFloat(rawKeyFigure);
    const contractFigureValue = parseFloat(contractFigure);

    if (!isNaN(keyFigureValue) && !isNaN(contractFigureValue)) {
      const difference = keyFigureValue - contractFigureValue;
      const percentageDifference = (difference / keyFigureValue) * 100;

      if (percentageDifference <= 0) {
        keyFigureColor = 'success.main';
        IconComponent = ArrowDropDownOutlinedIcon;
      } else if (percentageDifference <= 20) {
        keyFigureColor = 'warning.main';
        IconComponent = ArrowDropUpOutlinedIcon;
      } else {
        keyFigureColor = 'error.main';
        IconComponent = ArrowDropUpOutlinedIcon;
      }
    }
  }

  return (
    <CardContainer>
      <CardHeader title={title} />
      <Box padding={'10px'} display='flex' alignItems='center'>
        <Typography variant='h2' color={keyFigureColor}>
          {keyFigure}
        </Typography>
        {IconComponent && (
          <IconComponent sx={{ color: keyFigureColor, marginLeft: '8px' }} />
        )}
      </Box>

      {contractFigure !== 'N/A' && (
        <Typography paddingTop={'7px'} variant='body1'>
          Contract: {contractFigure}
        </Typography>
      )}
    </CardContainer>
  );
};

export default KeyFiguresSmall;
